import React from 'react';
import { useI18n } from '../i18n';

interface ConfirmDeleteModalProps {
  title: string;
  message?: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDeleteModal({
  title,
  message,
  isDeleting,
  onConfirm,
  onCancel,
}: ConfirmDeleteModalProps) {
  const { t } = useI18n();
  return (
    <div className="modal-overlay">
      <div className="modal modal--sm">
        <div className="modal__header">
          <h2 className="modal__title">{title}</h2>
        </div>
        <p className="text-muted" style={{ marginBottom: 24 }}>
          {message ?? t('Are you sure? This action cannot be undone.')}
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            type="button"
            className="btn btn--secondary"
            onClick={onCancel}
            disabled={isDeleting}
          >
            {t('Cancel')}
          </button>
          <button
            type="button"
            className="btn btn--danger"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? t('Deleting...') : t('Confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
